<script>
export default {
    name: "section-post",
    mounted() {
    },
    props: {
        post: {
            required: true
        }
    },
}
</script>

<template>
    <article v-if="post && post.content" v-html="post.content.rendered"></article>
</template>

<style scoped lang="scss">
</style>
